import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import { AddButton } from "../../../../components/mui/Buttons/Buttons";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import BookingComponent from "./BookingComponent";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getCheckedShiftDetails } from "../../../../redux/features/trasportationSlice";
import useResponsive from "../../../../Hooks/useResponsive";
import PaymentAlert from "./PaymentAlert";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const AddTransport = ({ dispatchParams }) => {
  const [open, setOpen] = useState(false);
  const [isMorningDisabled, setIsMorningDisabled] = useState(true);
  const [isEveningDisabled, setIsEveningDisabled] = useState(true);
  const [direction, setDirection] = useState("row");
  const mdDown = useResponsive("down", "md");
  useEffect(() => {
    if (mdDown) {
      setDirection("column");
    } else {
      setDirection("row");
    }
  }, [mdDown]);
  const [bookingDate, setBookingDate] = useState(dayjs().format("YYYY-MM-DD")); //SET AS TODAY DATE
  const dispatch = useDispatch();
  const { loading } = useSelector((store) => store.transportation);
  const [checked, setChecked] = useState({
    morningShift: false,
    eveningShift: false,
  });

  useEffect(() => {
    // //MORNING SEAT RESERVATION TIME AVAILABILITY FOR BOOKING
    // const nowTime = dayjs().format("HH:mm"); // Get the current time in "HH:mm" format
    // const morningShiftStartTime = "20:00"; // 8:00 PM
    // const morningShiftEndTime = "08:00"; // 8:00 AM
    // if (
    //   (nowTime >= morningShiftStartTime && nowTime <= "23:59") || // Between 8 PM and midnight 11:59PM
    //   (nowTime >= "00:00" && nowTime <= morningShiftEndTime) // Between midnight 12:00 AM and 8 AM
    // ) {
    //   setIsMorningDisabled(false); // Morning shift IS ENABLED
    // } else {
    //   setIsMorningDisabled(true); // Morning shift is DISABLED
    // }

    if (open) {
      const nowHour = dayjs().hour();
      const morningShiftStartTime = 20; // 8:00 PM
      const morningShiftEndTime = 8; // 8:00 AM
      if (nowHour >= morningShiftStartTime || nowHour < morningShiftEndTime) {
        setIsMorningDisabled(false);
      } else {
        setIsMorningDisabled(true);
      }

      //EVENING SEAT RESERVATION TIME AVAILABILITY FOR BOOKING
      const now = dayjs(); // Current time
      const eveningShiftStartTime = dayjs().set("hour", 12).set("minute", 0); // 12 PM
      const eveningShiftEndTime = dayjs().set("hour", 18).set("minute", 0); // 6 PM

      // Check if the current time is between 12 PM and 6 PM (inclusive)
      if (
        now.isSameOrAfter(eveningShiftStartTime) && // Includes 12:00 PM
        now.isSameOrBefore(eveningShiftEndTime) // Includes 6:00 PM
      ) {
        setIsEveningDisabled(false); // Enable evening shift
      } else {
        setIsEveningDisabled(true); // Disable evening shift
      }
    }
  }, [open]);

  //WHEN THE CHECK BOX SELCTED IT WILL TRIGGER
  useEffect(() => {
    let date = dayjs().format("YYYY-MM-DD"); //INITIAL CASE TODAY DATE
    const nowTime = dayjs().format("HH:mm"); //USER ENTERING TIME
    if (nowTime >= "19:58" && nowTime <= "23:59") {
      //IF THE TIME IN BETWEEN 7 58 PM TO 12 AM THE DAY SHOULD BE SELECTED AS NEXT DAY OTHER WISE SAME DAY
      date = dayjs().add(1, "day").format("YYYY-MM-DD");
    } else {
      date = dayjs().format("YYYY-MM-DD");
    }
    setBookingDate(date);
    if (checked.morningShift) {
      dispatch(getCheckedShiftDetails({ shiftId: 3, date: date }));
    } else if (checked.eveningShift) {
      dispatch(getCheckedShiftDetails({ shiftId: 4, date: date }));
    }
  }, [checked.morningShift, checked.eveningShift]);

  const handleChange = (event) => {
    //CHECK SELECTION FOR MORNING SHIFT AND EVENING SHIFT
    const { checked, name } = event.target;
    if (name === "morningShift" && checked) {
      setChecked((prev) => ({
        ...prev,
        morningShift: true,
        eveningShift: false,
      }));
    } else if (name === "eveningShift" && checked) {
      setChecked((prev) => ({
        ...prev,
        morningShift: false,
        eveningShift: true,
      }));
    } else {
      setChecked((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }
  };

  const closeButtonFunction = () => {
    //ON CLOSING THE MODAL OF MARKED CHECK BOX MADE TO RESET TO INITIAL CONDITION
    setChecked({
      morningShift: false,
      eveningShift: false,
    });
    setOpen(false);
  };
  return (
    <GlobalDialog
      maxWidth={"md"}
      fullWidth
      title={
        <>
          <Typography variant="body1">
            Morning Shift Booking : 8 PM - 8 AM
          </Typography>
          <Typography variant="body1">
            Evening Shift Booking : 12 PM - 6 PM
          </Typography>
        </>
      }
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={closeButtonFunction}
      popupButton={
        <>
          <AddButton
            size={mdDown ? "small" : "large"}
            action={() => {
              setOpen(true);
            }}
          >
            Reserve Seat
          </AddButton>
        </>
      }
      content={
        <>
          <Box>
            <PaymentAlert />
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange}
                    name="morningShift"
                    checked={checked.morningShift}
                    disabled={isMorningDisabled}
                  />
                }
                label="Morning Shift"
              />

              {checked.morningShift && (
                <BookingComponent
                  date={bookingDate}
                  shiftId={3}
                  closeButtonFunction={closeButtonFunction}
                  dispatchParams={dispatchParams}
                />
              )}
              <FormControlLabel
                disabled={isEveningDisabled}
                control={
                  <Checkbox
                    onChange={handleChange}
                    name="eveningShift"
                    checked={checked.eveningShift}
                  />
                }
                label="Evening Shift"
              />
              {checked.eveningShift && (
                <BookingComponent
                  date={bookingDate}
                  shiftId={4}
                  closeButtonFunction={closeButtonFunction}
                  dispatchParams={dispatchParams}
                />
              )}
            </FormGroup>
          </Box>
        </>
      }
    />
  );
};

export default AddTransport;
